<p>
    <mat-icon svgIcon="record" aria-hidden="false" aria-label="record"></mat-icon>
    {{ "posts.table.headers.record" | translate }} : {{post.horse.raceRecord}}
</p>
<p>
    <mat-icon svgIcon="money" aria-hidden="false" aria-label="total earn"></mat-icon>
    {{ "posts.table.headers.total_earn" | translate }} : {{post.horse.totalEarn | euro }}
</p>
<div class="secondary-info__location-and-category">
    <div *ngIf="!post.category" class="secondary-info__category">aucune catégorie</div>
    <div *ngIf="post.category" class="secondary-info__category">
        {{"posts.actions.create.fields.category.options." + (post.category | lowercase) | translate }}
    </div>
</div>
<div class="main-info__sub">
    <div class="negociate" *ngIf="post.toNegociate">{{ "posts.actions.display.negotiable" | translate }}</div>
    <span class="price">{{post.sellPrice | euro }}</span>
<!--    <mat-icon svgIcon="currency-euro" aria-hidden="false" aria-label="currency-euro"></mat-icon>-->
</div>
